import { memo } from 'react';

const SelectedItems = () => {
  return (
    <div>Selected Items</div> // TODO
  );
};

export default memo(SelectedItems);